import { useNavigate } from "react-router-dom";
import './index.scss'


interface NavBarProps {
    backTitle: string;
    onBackClick?: () => void;
    title?: any;
    titleStyle?: React.CSSProperties;
    titleString?: string;
}
  
  

export const NavBar = ({ backTitle, onBackClick ,title, titleStyle, titleString}: NavBarProps) => {

    const navigate = useNavigate()

    const handleBackClick = () => {
        if (onBackClick !== undefined) {
            onBackClick()
        } else {
            navigate(-1)
        }
    }

    const backIcon = backTitle === '退出答题' ? require('../../assets/img/m-com-back-icon-exit.png') 
    : require('../../assets/img/m-com-back-icon-back.png')
    
    return (
        <div className="navigationBar">
            <div className="backBtn" onClick={handleBackClick}>
                <img src={backIcon} />
                <p>{backTitle}</p>
            </div>
            {
                (title && titleStyle) && <img src={title} style={titleStyle}/>
            }
            {
                (titleString && titleStyle) && <p style={titleStyle}>{titleString}</p>
            }
        </div>
    )
    
}